import React, { Component } from 'react';
import { connect } from 'react-redux';
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";
import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}


class HospitalManagment extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        return (
            <div className="">
                <Helmet>
                    <title>Hospital & Clinical Management Software Solutions | KlinicQ</title>
                    <meta 
                        name="description" 
                        content="Optimize operations with KlinicQ Hospital Management System. Manage EMR, billing, and pharmacy in one secure cloud platform. Enhance your clinical workflow." 
                    />
                      <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "name": "KlinicQ",
          "url": "https://www.klinicq.com",
          "logo": "https://www.klinicq.com/logo.png"
        },
        {
          "@type": "SoftwareApplication",
          "name": "KlinicQ Hospital & Clinical Management System",
          "applicationCategory": "MedicalBusinessSoftware",
          "operatingSystem": "Web-based, Cloud",
          "description":
            "KlinicQ Hospital and Clinical Management System helps hospitals and clinics manage EMR, appointments, token management, billing, pharmacy, analytics, and tele-consultations securely.",
          "publisher": {
            "@type": "Organization",
            "name": "KlinicQ"
          },
          "featureList": [
            "Hospital Management System",
            "Clinical Management System",
            "Token Management System",
            "Appointment Scheduling",
            "Tele-consultation",
            "Electronic Medical Records (EMR)",
            "Analytics Dashboard",
            "Online Payments & QR Check-in"
          ]
        },
        {
          "@type": "WebPage",
          "name": "Hospital & Clinical Management Software Solutions | KlinicQ",
          "description":
            "Optimize healthcare operations with KlinicQ Hospital & Clinical Management Software. A complete cloud-based solution for hospitals and clinics.",
          "url": "https://www.klinicq.com/hospitalmanagement",
          "isPartOf": {
            "@type": "WebSite",
            "name": "KlinicQ",
            "url": "https://www.klinicq.com"
          }
        }
      ]
    })}
  </script>
                </Helmet>

                <div className="">
                
                    <div className="">
                  
<Headerweb/>
<div className='product-section'>
    
 <section id="pharma-hero-section">
  <div className="pharma-hero-background">
    <div className="hospitalmang-hero-gradient"></div>
    <img
      src={require("../../src/assets/images/website/hospital-software-doctor-patient-consultation.webp")}
      alt="Hospital and clinical management system software for efficient healthcare operations"
      className="pharma-hero-bg-image"
    />
  </div>
  <div className="pharma-container pharma-hero-content-container">
    <div className="pharma-hero-text">
      <h1>Hospital &amp; Clinical Management System</h1>
      <p>
        A Clinical Management System (CMS) is a software solution designed to streamline and enhance the administrative and clinical functions within healthcare facilities. It plays a crucial role in managing patient information, improving efficiency, ensuring regulatory compliance, and enhancing overall patient care. Here are some key components and features typically found in a Clinical Management System
      </p>
    </div>
   
  </div>
</section>

    <div id="hospitalmang-feature-one">
  <div class="hospitalmang-main-container">
    <div class="hospitalmang-feature-block">
      <div class="hospitalmang-feature-image-wrapper">
        <img src={require("../../src/assets/images/website/doctor-patient-consultation-hospital-management.webp")} alt="Doctor using KlinicQ hospital management system to optimize patient scheduling and operations" loading="eager" fetchpriority="high" />
      </div>
      <div class="hospitalmang-feature-text-wrapper">
        <p>The KlinicQ's algorithm has been developed to perform line balancing to schedule the workload based on the doctor's availability maintained in the shift planner, which could help optimize the schedule effectively. It simplifies the check-in process at the front desk. It digitally keeps the visitor's records, patient's discharge summary, medicine details, and clinic staff details so that clinic front office staff can focus on their work as patients join the virtual queue. It improves productivity and Operational efficiency.</p>
        <p>The hospital portal is designed to manage multi-specialty and different consultation modes (Token Management System, Appointment Management System & Tele-consultation). Each hospital is registered with a unique location ID, which shows the hospital/clinic in the GoogleMaps view with the wait time based on the specialization. Also, the dashboard displays the travel distance between the visitor location and the hospital travel time to the hospital to arrive at the clinic on time to avoid no-shows.</p>
        <p>KlinicQ's advanced token management system algorithm schedules a virtual queue and allocates the token number to the visitors so that visitors don't have to wait in the waiting room physically.</p>
        <p>The KlinicQ token management system keeps track of each visitor's token position in a queue and updates the hospital and visitors on the progress. Clinics can operate with minimal resources and less space due to sequenced line, and patients can use their time effectively instead of wait at the waiting room, and there is no need to have a larger area and the infrastructure at the Clinic waiting room.</p>
      </div>
    </div>
  </div>
</div>

<div id="hospitalmang-feature-two">
  <div class="hospitalmang-main-container">
    <div class="hospitalmang-feature-block">
      <div class="hospitalmang-feature-text-wrapper">
        <p>KlinicQ Clinical Management System fills the appointment schedule automatically without any manual intervention, and it handles appointment cancellation, allocates grace time for patients who arrive to their appointment late, and calculates the schedule based on the doctor's arrival time at the hospital so that minimal staff should be enough to manage the operations.</p>
        <p>As the KlinicQ Token management algorithm allocates the appointment time for each token, visitors could arrive at the hospital before their appointment time, which could limit the number of visitors in the waiting room.</p>
        <p>
  KlinicQ also includes a built-in analytics dashboard for hospital administrators, offering insights into appointment trends, patient flow, doctor performance, and peak consultation hours. These metrics help optimize resource allocation, reduce wait times, and improve overall operational efficiency.
</p>

       
        <p>Patient's medical records like prescriptions, discharge summaries, and vital details of their previous consultation can also be scanned or uploaded the images of all their previous medical records digitally to access anytime when required & it helps the doctor to go through all reports to provide an effective treatment.</p>
        <p>The KlinicQ application has additional features like General health tips, BMI, and vital details, and also, the payment gateway is enabled for online payments, QR code easier, and touchless check-in process.</p>
      </div>
      <div class="hospitalmang-feature-image-wrapper">
        <img src={require("../../src/assets/images/website/hospital-clinical-management-system-dashboard.webp")} alt="Medical professionals reviewing patient data using clinical management software" />
      </div>
    </div>
  </div>
</div>

 <div className='single-click py-5'>
          <div className='container'>
            <div className='row m-0'>
              {/* <div className='col-lg-4 col-12 mb-lg-0 mb-3 slide-left visible'>
                
              </div> */}
              <div className='col-lg-12 col-12 py-lg-0 py-md-0 py-2 slide-right visible text-center'>

              <h3>Expert Care, Anytime, Anywhere </h3>
                <p>Experience healthcare on your terms. Access licensed doctors instantly for personalized advice and seamless health management, wherever you are. Say goodbye to waiting rooms and rigid appointments – your health is now in your hands.</p>
              </div>
                     <div className="image-container1">
    {/* <img src={require("../../src/assets/images/website/Rectangle19.png")} className="background-image1" alt="Background" /> */}
    <img src={require("../../src/assets/images/website/healthcare-mobile-app-patient-dashboard-video-consultation.webp")} className="foreground-image1" alt="Online doctor consultation and remote healthcare services illustration" />
</div>
            </div>
          </div>
        </div>
        <div>
          </div>


                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
  
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(HospitalManagment);